import { FC, ReactNode } from "react";
import styled from "styled-components";

import { Logo, Styles as LogoStyles } from "@/components/Logo";

/** @public */
export const Styles = styled.div`
  background-color: white;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Box = styled.div`
  border-radius: 10px;
  background-color: var(--primary-background-color);
  width: 384px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--primary-text-color);

  ${LogoStyles} {
    margin-bottom: 24px;
  }
`;

type Props = {
  children: ReactNode;
};

export const FullBox: FC<Props> = ({ children }) => {
  return (
    <Styles>
      <Box>
        <Logo />
        {children}
      </Box>
    </Styles>
  );
};
